import {useId, useState} from 'react';

export interface CliCommandBlockProps {
  command?: string;
}

export function CliCommandBlock({command}: CliCommandBlockProps) {
  const [copied, setCopied] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  if (!command) return null;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(command);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <details className="mt-2 text-xs" open={isOpen}>
      <summary
        className="cursor-pointer text-gray-500 hover:text-gray-700 select-none"
        aria-controls={contentId}
        aria-expanded={isOpen}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen((v) => !v);
        }}
        onKeyDown={(e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          setIsOpen((v) => !v);
        }}
      >
        CLI equivalent
      </summary>
      <div id={contentId} className="mt-1 relative">
        <pre className="bg-gray-900 text-green-400 rounded p-3 pr-16 overflow-x-auto font-mono text-xs">
          {command}
        </pre>
        <button
          onClick={handleCopy}
          className="absolute top-2 right-2 text-xs text-gray-400 hover:text-white bg-gray-700 hover:bg-gray-600 rounded px-2 py-1"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
    </details>
  );
}
